import script from "./PaymentRedirectAli.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentRedirectAli.vue?vue&type=script&setup=true&lang=js"

import "./PaymentRedirectAli.vue?vue&type=style&index=0&id=02ff6861&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ff6861"]])

export default __exports__